export default __webpack_public_path__ + "static/media/food-and-drink.1f042b44.svg";